/**
 * Journal de vie de l'ecart — **contrat partage** (regle 14, CLAUDE.md v11.2).
 *
 * Le **calcul** des evenements vit cote API (`journal.domain.ts`) : il fait de
 * l'arithmetique decimale exacte, et `@kn/shared` ne depend que de zod — pas de
 * Prisma, donc pas de `Decimal`, et surtout pas de float sur des UVC (regle 5).
 *
 * Ici : les types que les deux cotes echangent, et le **tri du fil**, qui ne
 * manipule que des horodatages.
 */
export const TYPE_EVENEMENT_LABELS = {
    APPARITION: 'Apparition',
    EVOLUTION: 'Évolution',
    SOLDE: 'Soldé',
};
export const SENS_EVOLUTION_LABELS = {
    AMELIORATION: 'Amélioration',
    AGGRAVATION: 'Aggravation',
    CHANGEMENT_DE_SENS: 'Changement de sens',
};
/**
 * Le fil chronologique de la fiche : ce que la machine a constate et ce que les
 * humains ont fait, **dans le meme ruban**.
 *
 * Les separer obligerait a lire deux colonnes en parallele pour repondre a la
 * seule question qui compte : « que s'est-il passe sur cet ecart, et dans quel
 * ordre ». Du plus recent au plus ancien — on arrive par la derniere nouvelle.
 *
 * A horodatage egal, l'ordre reste **stable** : c'est un tri, pas une loterie.
 */
export function filUnifie(entrees) {
    const tout = [
        ...entrees.commentaires,
        ...entrees.evenements,
        ...entrees.validations,
        ...(entrees.rapprochements ?? []),
    ];
    return tout
        .map((entree, rang) => ({ entree, rang }))
        .sort((a, b) => b.entree.horodatage.localeCompare(a.entree.horodatage) || a.rang - b.rang)
        .map(({ entree }) => entree);
}
//# sourceMappingURL=discrepancy-journal.js.map